<div id="main-div" *transloco="let t">
	<div id="sh-my-account-nav-logo-div">
		<a id="sh-my-account-nav-logo-button" [routerLink]="navigateTo">
			<img
				id="sh-my-account-nav-logo-img"
				alt="{{ t('cloud.shure-cloud.home') }}"
				src="../assets/images/shure_logo_icon.svg"
			/>
			<span id="sh-my-account-nav-logo-span">{{ t('cloud.shared.side-nav.shure-cloud') }}</span>
		</a>
	</div>
	<hr id="sh-my-account-nav-divider" class="prism-divider" orientation="horizontal" />
	<div id="sh-my-account-nav-div">
		<span id="sh-my-account-nav-title-span">{{ t('cloud.shared.side-nav.my-account') }}</span>
	</div>
	<prism-nav-group id="sh-my-account-nav-group">
		<prism-nav-button
			[routerLink]="['account']"
			[routerLinkActiveOptions]="{ exact: true }"
			routerLinkActive
			#account="routerLinkActive"
			[selected]="account.isActive"
		>
			<prism-icon slot="icon" id="sh-my-account-nav-profile-icon" icon="account_circle"></prism-icon>
			<span id="sh-my-account-nav-profile-span">{{ t('cloud.shared.side-nav.profile') }}</span>
		</prism-nav-button>
		<prism-nav-button
			[routerLink]="['account/marketing-preference']"
			routerLinkActive
			#accountMarketing="routerLinkActive"
			[selected]="accountMarketing.isActive"
		>
			<prism-icon slot="icon" icon="newspaper" id="sh-my-account-nav-marketing-icon"></prism-icon>
			<span id="sh-my-account-nav-preference-span">{{ t('cloud.shared.side-nav.marketing-preferences') }}</span>
		</prism-nav-button>
		@if (isMotivSubscriptionsEnable$ | async) {
			<prism-nav-button
				secondary
				[routerLink]="['account/subscriptions']"
				routerLinkActive
				#subscriptions="routerLinkActive"
				[selected]="subscriptions.isActive"
			>
				<prism-icon size="sm" slot="icon" icon="monetization_on"></prism-icon>
				<span id="sh-my-account-nav-subscriptions-span">{{
					t('cloud.shared.motiv-subscriptions.subscriptions')
				}}</span>
			</prism-nav-button>
		}
	</prism-nav-group>
	<!-- <mat-nav-list>
		<mat-list-item *ngIf="showSideNavItem" routerLinkActive="mat-menu-item-active" disabled>
			<mat-icon fontSet="prism-mat" fontIcon="storage" id="sh-my-account-nav-address-icon"></mat-icon>
			<span class="mat-list-text" id="sh-my-account-nav-address-span"> {{ t('addresses') }} </span>
		</mat-list-item>
		<mat-list-item *ngIf="showSideNavItem" routerLinkActive="mat-menu-item-active" disabled>
			<mat-icon fontSet="prism-mat" fontIcon="info" id="sh-my-account-nav-info-icon"></mat-icon>
			<span class="mat-list-text" id="sh-my-account-nav-info-span"> {{ t('about') }} </span>
		</mat-list-item>
		
	</mat-nav-list>-->
</div>
